import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context6; _forEachInstanceProperty(_context6 = ownKeys(Object(source), true)).call(_context6, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context7; _forEachInstanceProperty(_context7 = ownKeys(Object(source))).call(_context7, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import Box from '@rexlabs/box';
import { useToken } from '@rexlabs/styling';
import { Checkbox } from './checkbox';
import { get, isArray, noop } from 'lodash';

function fakeEvent(value) {
  return {
    target: {
      value: value
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    persist: function persist() {}
  };
}

/**
 * The `CheckboxGroup` can be used as a single input to group related checkboxes.
 */
function CheckboxGroup(_ref) {
  var value = _ref.value,
      name = _ref.name,
      _ref$orientation = _ref.orientation,
      orientation = _ref$orientation === void 0 ? 'vertical' : _ref$orientation,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? noop : _ref$onBlur,
      inputProps = _objectWithoutProperties(_ref, ["value", "name", "orientation", "options", "onChange", "onBlur"]);

  var token = useToken();
  var direction = orientation === 'vertical' ? 'column' : 'row';
  return /*#__PURE__*/React.createElement(Box, {
    sx: token('spacing.m'),
    flexDirection: direction
  }, _mapInstanceProperty(options).call(options, function (option) {
    var _context, _context4, _context5;

    // We want to handle both cases here, using CheckboxGroup for array values as well as
    // using it for object values
    var checked = isArray(value) ? _includesInstanceProperty(_context = value).call(_context, option.value) : get(value, option.value);

    function handleChange() {
      var _context2, _context3;

      var newValue = isArray(value) ? checked ? _filterInstanceProperty(_context2 = value).call(_context2, function (i) {
        return i !== option.value;
      }) : _concatInstanceProperty(_context3 = []).call(_context3, _toConsumableArray(value), [option.value]) : _objectSpread(_objectSpread({}, value), {}, _defineProperty({}, option.value, !checked));
      var event = fakeEvent(newValue);
      onChange(event);
      onBlur(event);
    }

    return /*#__PURE__*/React.createElement(Checkbox, _extends({}, inputProps, option === null || option === void 0 ? void 0 : option.props, {
      key: option.value,
      id: _concatInstanceProperty(_context4 = "".concat(name, ".")).call(_context4, option.value),
      name: _concatInstanceProperty(_context5 = "".concat(name, ".")).call(_context5, option.value),
      label: option.label || option.value,
      value: checked,
      onChange: handleChange
    }));
  }));
}

export default CheckboxGroup;